module.exports = __webpack_public_path__ + "img/tappay.37070fce.svg";